import React, { createContext, useCallback, useContext, useState } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as InformationCircle } from "images/icons/information-circle.svg";
import { ReactComponent as RemoveIcon } from "images/icons/remove.svg";

const Alert = ({ message, onDismiss }: { message: string; onDismiss: () => void }) => {
  return <div className="notice">
    <InformationCircle className="icon streamline-icon"/>
    {message}

    <div className="notice-controls">
      <button className="button is-icon-only is-ghost is-raised has-plain-icon" onClick={onDismiss}>
        <RemoveIcon className="icon streamline-icon" />
      </button>
    </div>
  </div>
}

export type AlertContext = (message: string) => void;

const AlertContext = createContext<AlertContext>(() => {/* noop */});

export const useShowAlert = (): AlertContext => {
  const maybeShowAlert = useContext(AlertContext);

  if (!maybeShowAlert)
    throw "Missing show alert context";

  return maybeShowAlert;
}

export const AlertProvider = ({ children }: { children: React.ReactNode }) => {
  const [alertMessage, setAlertMessage] = useState<string | undefined>(undefined);

  const contextValue: AlertContext = useCallback((message: string) => {
    setAlertMessage(message);
  }, [])

  const flashContainer = document.getElementById('flash-notice')

  return <AlertContext.Provider value={contextValue}>
    {flashContainer && alertMessage ? createPortal(<Alert message={alertMessage} onDismiss={() => setAlertMessage(undefined)}/>, flashContainer) : null}
    {children}
  </AlertContext.Provider>
}
